import { render, staticRenderFns } from "./EDesempenho.vue?vue&type=template&id=64069362&scoped=true"
import script from "./EDesempenho.vue?vue&type=script&lang=js"
export * from "./EDesempenho.vue?vue&type=script&lang=js"
import style0 from "./EDesempenho.vue?vue&type=style&index=0&id=64069362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64069362",
  null
  
)

export default component.exports